import React from "react";
import { Header, Icon } from "semantic-ui-react";

interface IProp {
  header: string;
  subheader: string;
  icon: any;
}
const PageHeader = ({ header, subheader, icon }: IProp) => {
  return (
    <Header as="h2">
      <Icon name={icon} />
      <Header.Content>
        {header}
        <Header.Subheader>{subheader}</Header.Subheader>
      </Header.Content>
    </Header>
  );
};

export default PageHeader;
